import { Button, CheckboxFormField, ClassName, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import DashboardRibbon from 'components/foundation/dashboard/DashboardRibbon/DashboardRibbon';
import { useToastOpen } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';
import { isEqual } from 'lodash';
import { useState } from 'react';

export interface ISafetyIncidentFormData {
  createIncident: boolean;
  manageIncident: boolean;
}

export interface ISafetyIncidentFormProps {
  className?: ClassName;
  positionId: string;
  onSubmit: () => void;
  createIncident: boolean;
  manageIncident: boolean;
}

const SafetyIncidentForm = (props: ISafetyIncidentFormProps) => {
  const { className, positionId, onSubmit, createIncident, manageIncident } = props;

  const [formData] = useState<ISafetyIncidentFormData>({
    createIncident,
    manageIncident,
  });
  const [, update] = usePositionUpdate();
  const toast = useToastOpen();
  const initialFormData: ISafetyIncidentFormData = {
    createIncident,
    manageIncident,
  };

  const handleFormSubmit = async (formData: ISafetyIncidentFormData) => {
    if (!isEqual(initialFormData, formData)) {
      try {
        await update({
          id: positionId,
          createIncident: formData.createIncident,
          manageIncident: formData.createIncident ? formData.manageIncident : false,
        });
      } catch (error) {
        toast({ label: t('Something went wrong. Please try again later.') });
      }
    }
    onSubmit();
  };

  const createLabel = () => (
    <>
      <h4>{t('Create Incident Reports')}</h4>
      <h6>{t('File incident reports for self and others.')}</h6>
    </>
  );

  const manageLabel = () => (
    <>
      <h4>{t('Manage Incident Reports')}</h4>
      <h6>{t('View, edit, delete, and review all incidents reports.')}</h6>
    </>
  );

  const renderFormFields = (form: IFormRender<ISafetyIncidentFormData>) => (
    <div className={'m-5 pt-8'}>
      <CheckboxFormField name={'createIncident'} form={form} label={createLabel()} />
      {form.state.data.createIncident && (
        <DashboardRibbon theme={Theme.LIGHT}>
          <CheckboxFormField name={'manageIncident'} form={form} label={manageLabel()} />
        </DashboardRibbon>
      )}
      <Button onClick={form.handleSubmit} type="primary" className={'mt-4'}>
        {t('Update')}
      </Button>
    </div>
  );

  const classes = classNames('safety-incident-form', className);

  return <Form render={renderFormFields} onSubmit={handleFormSubmit} data={formData} className={classes} />;
};

export default SafetyIncidentForm;
